export enum SourceType {
  WEB = 'WEB',
  BACKOFFICE = 'BACKOFFICE',
  DOCUMENT = 'DOCUMENT',
  THIRD_PARTY = 'THIRD_PARTY',
}
